import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getMyCompanyListData, getMyCompanyListTotal, getLoadingStatus } from '../../redux/company/selectors';
import { companyActions } from '../../redux/company/actions';

export const useMyCompanyListData = () => {
  const dispatch = useDispatch();
  const myCompanyListData = useSelector(getMyCompanyListData);
  const myCompanyListTotal = useSelector(getMyCompanyListTotal);
  const loading = useSelector(getLoadingStatus);

  useEffect(() => {
    if (!myCompanyListData) {
      dispatch(companyActions.loadMyCompanyList());
    }
  }, [dispatch]);

  return { myCompanyListData, myCompanyListTotal, loading };
};
